import { AxiosResponse } from "axios";
import { CommunicationFormDataProps } from "../../types/communication";
import api from "../api";

type Response = {};

export async function saveCommunicationRequest(
  token: string,
  data: CommunicationFormDataProps
): Promise<Response> {
  try {
    const response: AxiosResponse<Response> = await api.post(
      "/communication/", data,
      {
        params: { token },
        headers: {
          jwt: token,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }

    throw new Error();
  }
}
